var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRisk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 30,
    viewBox: "0 0 26 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0L0 5.45455V13.6364C0 21.2045 5.54658 28.2818 13 30C20.4534 28.2817 26 21.2042 26 13.6364V5.45455L13 0ZM13 5.45455C14.1494 5.45455 15.2514 5.88555 16.0643 6.6526C16.8768 7.41995 17.3333 8.46031 17.3333 9.54545C17.3333 10.6306 16.8768 11.6709 16.0643 12.4383C15.2515 13.2054 14.1494 13.6364 13 13.6364C11.8506 13.6364 10.7486 13.2054 9.93571 12.4383C9.12321 11.671 8.66667 10.6306 8.66667 9.54545C8.66667 8.46031 9.12321 7.41997 9.93571 6.6526C10.7485 5.88555 11.8506 5.45455 13 5.45455ZM20.4098 21.8182C18.6597 24.3473 16.0446 26.2339 13 27.1638C9.95536 26.2339 7.34025 24.3473 5.59016 21.8182C5.09912 21.1364 4.68033 20.4545 4.33333 19.732C4.33333 17.482 8.24786 15.6411 13 15.6411C17.7521 15.6411 21.6667 17.4412 21.6667 19.732C21.3201 20.4546 20.9012 21.1364 20.4098 21.8182Z",
    fill: "#183171"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRisk);
export default __webpack_public_path__ + "static/media/risk.ce9b1e3c8ed1f01102944963250eb903.svg";
export { ForwardRef as ReactComponent };